import { ModuleCarrierRecommendation } from './ModuleCarrierRecommendation/ModuleCarrierRecommendation';
import { ModuleEfficiencyRecommendation } from './ModuleEfficiencyRecommendation/ModuleEfficiencyRecommendation';
import { DownloadToast } from '@modules/BulkDownloadModule';

export const Modules = () => (
	<>
		<ModuleCarrierRecommendation />
		<ModuleEfficiencyRecommendation />
		<DownloadToast />
	</>
);
